import { render } from "./UserShop.vue?vue&type=template&id=469575f9"
import script from "./UserShop.vue?vue&type=script&lang=js"
export * from "./UserShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__